import useShouldUseChat from 'tripPlanner/hooks/useShouldUseChat'

function isUnsupportedHotelNlsQuery(isQueryWellSupported: boolean | string | undefined): boolean {
  return isQueryWellSupported === false || isQueryWellSupported === 'false'
}

export function useHotelSearchTripPlannerBanner(isQueryWellSupported: boolean | string | undefined): boolean {
  const shouldUseChat = useShouldUseChat()
  return isUnsupportedHotelNlsQuery(isQueryWellSupported) && shouldUseChat
}
